import { Exclude } from 'class-transformer'

import { BaseNodeModelData, IBaseData } from "../../../../BaseNode/BaseNodeDataModel";
import { NodeTypes } from '../../../../index'
import { DelayNodeData } from '../DelayNode'
import {
  DelayDateType,
  DelayPropertyType,
  DelayIntervalType
} from '../DelayTypes'
import { DelayType } from '../DelayTypes/types'
import { DelayNodeProps } from '../types'
import ProxyDelayFabric from "./ProxyDelayFabric";
import {
  ProxyBaseDelayType,
  ProxyDelayPropertyType,
  ProxyDelayDateType,
  ProxyDelayIntervalType,
} from './ProxyDelayTypes'

export default class ProxyDelayData implements IBaseData {
  type = NodeTypes.Delay
  delay: ProxyBaseDelayType

  @Exclude()
  nodeProps: DelayNodeProps

  constructor(data: DelayNodeData, nodeProps: DelayNodeProps) {
    this.nodeProps = nodeProps

    if (data.delay instanceof DelayIntervalType) {
      this.delay = new ProxyDelayIntervalType(data.delay)
    } else if (data.delay instanceof DelayPropertyType) {
      this.delay = new ProxyDelayPropertyType(data.delay, { getProperties: nodeProps.getProperties })
    } else if (data.delay instanceof DelayDateType) {
      this.delay = new ProxyDelayDateType(data.delay)
    } else {
      throw new Error('Delay node data is not valid')
    }
  }

  swipeDelayType(type: DelayType): void {
    this.delay = ProxyDelayFabric.getDelayType(type, this.nodeProps)
  }

  getData(): BaseNodeModelData {
    return this
  }
}
